'use client'
import {
  TAG_QUERY
} from "./chunk-TT4DXTR5.mjs";
import {
  CATEGORY_QUERY
} from "./chunk-ZZ3DUO5U.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/organizer/details.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getOrganizerDetails($lang: String, $where: OrganizerFilter) {
  organizerCollection(locale: $lang, where: $where) {
    items {
      id
      title
      href
      slug
      logo{${IMAGE_QUERY}}
      categoriesCollection(limit: 10) {
        items {${CATEGORY_QUERY}}
      }
      tagsCollection(limit: 10){
        items {${TAG_QUERY}}
      }
    }
  }
}
`;
var getOrganizerDetails = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadValues({}, props));
    return res.organizerCollection.items[0] || null;
  } catch (error) {
    throw new Exception({ error, name: "getOrganizerDetailsException" });
  }
});
var useGetOrganizerDetails = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getOrganizerDetails", props],
    queryFn: () => getOrganizerDetails(props)
  }));
};

export {
  getOrganizerDetails,
  useGetOrganizerDetails
};
//# sourceMappingURL=chunk-KACGGGBX.mjs.map